import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import SettingsPage from "../ui/pages/settings/SettingsPage";
import ShowSettingsInteractor from "../interactor/settings/ShowSettingsInteractor";
import { RoleConstants } from "../common/Constants";

export default class SettingsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes({
      path: "/settings",
      page: this.createPage({
        Page: SettingsPage,
        action: this.showSettingsPage.bind(this)
      }),
      options: {
        secure: true,
        role: [
          RoleConstants.MIK_BO.MIK_ADMIN,
          RoleConstants.MIK_BO.MIK_OSOBLJE,
          RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
        ]
      }
    });
  }

  public showSettingsPage() {
    return this.application.container
      .resolve<ShowSettingsInteractor>("showSettings")
      .execute();
  }
}
